import makeStyles from '@mui/styles/makeStyles';
import CircularProgress from '@mui/material/CircularProgress';
import { FormattedMessage, useIntl } from 'react-intl';
import { shallowEqual, useSelector } from 'react-redux';
import { fromOrder } from '../../../store/rootReducer';
import { Feature } from '../../../models';

const useStyles = makeStyles(({
  root: {},
  container: {
    width: '100%',
  },
  namePriceContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    position: 'relative',
  },
  name: {
    fontSize: 14,
    fontWeight: 500,
    color: '#233145',
    width: '70%',
    marginBottom: 0,
  },
  sumPrice: {
    fontSize: 14,
    fontWeight: 600,
    color: '#22283c',
    top: 0,
    right: 0,
    position: 'absolute',
  },
  circleProgress: {
    top: 12,
    right: 0,
    position: 'absolute',
  },
  unitPriceBillingCycleContainer: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    width: '100%',
  },
  unitPrice: {
    fontSize: 12,
    fontWeight: 500,
    color: '#727993',
  },
  billingCycle: {
    fontSize: 12,
    fontWeight: 500,
    color: '#4d5369',
    bottom: 0,
    right: 0,
    position: 'absolute',
  },
  line: {
    border: 'none',
    borderTop: '1px dashed #d6dae4',
  },
  discountPrice: {
    fontSize: 14,
    fontWeight: 600,
    color: '#008060',
    position: 'absolute',
    top: 0,
    right: 0,
  },
}));

interface CreditItemProps {
  currentSubscription?: any,
  feature: Feature,
  planName: string,
  quotaType: string,
}

const CreditItem = (props: CreditItemProps) => {
  const {
    currentSubscription,
    feature,
    planName,
    quotaType,
  } = props;

  const classes = useStyles();
  const intl = useIntl();
  const preview = useSelector(fromOrder
    .selectProductPreviewByFeature(feature), shallowEqual);

  const loading = useSelector(fromOrder.selectPreviewLoading);

  const getQuotaForView = () => `${currentSubscription.quota} `;

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <div className={classes.namePriceContainer}>
          <p className={classes.name}>
            <FormattedMessage id={planName} />
          </p>
          {
            loading
              ? <CircularProgress className={classes.circleProgress} size={20} />
              : (
                <p className={classes.discountPrice}>
                  - $
                  {intl.formatNumber(Math.abs(preview?.creditAmount || 0))}
                </p>
              )
          }
        </div>
        <div className={classes.unitPriceBillingCycleContainer}>
          <p className={classes.unitPrice}>
            {getQuotaForView()}
            <FormattedMessage id="subscriptions.testops_platform.monthly" />
            {' '}
            <FormattedMessage id={quotaType} />
            {' '}
          </p>
        </div>
      </div>
      <div className={classes.line} />
    </div>
  );
};

export default CreditItem;
